import React from "react"
import CustomLink from "@components/helpers/CustomLink"

const Community = ({ slice }) => {
  const community = slice.primary
  return (
    <section className="community-section">
      <div className="community-section__container">
        <div className="community-section__wrapper">
          <h2 className="community-section__title">
            {community.community_title.text}
          </h2>
          <h3 className="community-section__subtitle">
            {community.subtitle.text}
          </h3>
          <div className="community-section__description">
            {community.description.text}
          </div>
        </div>
        <CustomLink
          className="community-section__btn button button-secondary"
          url={community.button_link.url}
        >
          {community.button_text.text}
        </CustomLink>
      </div>
    </section>
  )
}

export default Community
